// i18n area 'backups' — locale sv-SE (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.sv-SE.meta.json.
import type { enUS } from './backups'

export const svSE: typeof enUS = {
  ckpt: {
    contents: 'Tar emot',
    contentsHint:
      'Vad som får landa här. "Checkpoints" är klustrets konfiguration, "Datasäkerhetskopior" är de virtuella maskinernas: de två läsningarna kombineras, en destination får ta emot båda.',
    content: { checkpoints: 'Checkpoints', backups: 'Datasäkerhetskopior' },
    destinationsTitle: 'Backup-destinationer',
    checkpointsTitle: 'Checkpoints',
    restoreTitle: 'Återställning',
    addDestination: 'Lägg till destination',
    addDestinationTitle: 'Lägg till backup-destination',
    editDestinationTitle: 'Redigera destination',
    storage: 'Storage',
    storageHint:
      'En dir-lik storage (dir/NFS/CIFS/CephFS) — artefakterna är vanliga filer under plattformens namespace.',
    schedule: 'Schema',
    scheduleNone: 'Endast manuellt',
    scheduleHourly: 'Varje timme',
    scheduleDaily: 'Dagligen',
    scheduleWeekly: 'Varje vecka',
    scheduleHour: 'Klockslag',
    scheduleWeekday: 'Dag',
    scheduleHint:
      'Schemalagda checkpoints har ingen operatör som skriver in masterpassen: keystorens hemligheter paketeras som placeholders.',
    retention: 'Retention',
    retentionHint:
      'Hur många schemalagda checkpoints som ska behållas — sweepern tar bort de äldsta bortom antalet. Manuella och pre-återställnings-checkpoints tas aldrig bort.',
    paused: 'Pausad',
    pausedHint:
      'Operatörens blackout: så länge pausen varar planeras och gallras ingenting på den här destinationen — datapolicyer såväl som checkpoints. Pågående körningar rörs aldrig.',
    orphanRuns: '{n} föräldralösa körningar',
    orphanRunsHint:
      'Schemalagda körningar från policies som inte längre finns på denna destination: ingen retention styr dem — aldrig räknade, aldrig gallrade — och bara en hand raderar dem. Linsen ”backups” i tvirt diagnose namnger de borttagna policyerna.',
    rescan: 'Återadoptera artefakter',
    rescanTitle: 'Återadoption av artefakter för {name}',
    rescanHint:
      'Bygger om backupkatalogen (VM/CT/App) från manifesten för artefakterna på destinationen. Befintliga rader rörs aldrig; backuper av okända policyer förblir föräldralösa (gallras aldrig automatiskt). Steget efter en bootstrap-återställning.',
    masterpassDrWarning:
      'Katastrofscenario: LUKS-diskar kommer BARA tillbaka från en checkpoint MED masterpass. Schemalagda checkpoints packar platshållare — ta regelbundet en manuell checkpoint med masterpass.',
    policy: {
      title: 'Policyer för datasäkerhetskopior',
      hint: 'Namngivna policyer: vilka objekt (kind, taggar, scopes), hur ofta, när en körning får starta och hur många kopior som behålls. Enrolleringens gest stannar hos objektets ägare: taggar tilldelas på dess eget scope.',
      add: 'Lägg till policy',
      column: 'Datapolicyer',
      name: 'Namn',
      nameHint:
        'Policyns etikett, unik inom destinationen. Körningarna följer policyns stabila id: att byta namn är gratis; att radera den gör dess körningar föräldralösa (varken räknade eller gallrade).',
      kindLocked: 'Objektfamiljen för en befintlig policy kan inte ändras: skapa en ny policy.',
      kindLabel: 'Objekt',
      kind: { vm: 'Virtuella maskiner', ct: 'Containrar', app: 'Appar' },
      tags: 'Taggväljare',
      tagsHint: 'Par av tag=värde, kommaseparerade, i AND. Tomma taggar och scopes väljer ingenting — aldrig "allt".',
      scopes: 'Scopes',
      scopesHint: 'Scope-sökvägar (underträd), kommaseparerade, i OR med varandra.',
      windowStart: 'Fönster från',
      windowEnd: 'Fönster till',
      windowHint:
        'Körfönster (HH:MM, lokal tid; en start bortom slutet kliver över midnatt). Det styr bara STARTEN: en körning som drar över dödas aldrig.',
      mode: 'Läge',
      modeHint: 'Inkrementell rider på seriefamiljen; en bruten serie degraderar till en full, omtalad i journalen.',
      modeFull: 'Full',
      modeIncremental: 'Inkrementell',
      requireQuiesce: 'Kräv quiesce (guest agent)',
      paused: 'Policy pausad',
      retentionNone: 'Behåll allt',
      retentionCount: 'Antal',
      retentionGfs: 'GFS-ringar',
      gfs: { keepLast: 'Senaste', daily: 'Dagliga', weekly: 'Veckovisa', monthly: 'Månatliga', yearly: 'Årliga' },
      gfsHint:
        'För varje ring behålls den nyaste säkerhetskopian från var och en av de senaste N perioderna. En behållen säkerhetskopia håller hela sin kedja vid liv — aldrig en bas med föräldralösa.',
      lastRun: 'Senaste körning',
      neverRan: 'aldrig körd'
    },
    lastCheckpoint: 'Senaste checkpoint',
    neverRun: 'Aldrig tagen',
    createNow: 'Skapa checkpoint',
    createNowTitle: 'Skapa checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Skyddar keystorens hemliga värden (argon2id → AES-256-GCM, per värde). Den sparas aldrig: förvara den — utan den ger en återställning placeholders i stället för de riktiga hemligheterna.',
    masterpassEmptyHint: 'Lämna tomt för att paketera explicita placeholders i stället för hemligheterna.',
    createStarted: 'Checkpoint pågår…',
    destinationInUseError: "'{name}' innehåller fortfarande checkpoints — radera dem först.",
    origin: 'Ursprung',
    originManual: 'manuell',
    originSchedule: 'schemalagd',
    originPreRestore: 'pre-återställning',
    originPreChange: 'före ändring',
    preChangeRetention: 'Checkpoints före ändring',
    preChangeRetentionHint:
      'Tom = avstängt. Den första konfigurationsskrivningen efter en lugn period fryser här det föregående tillståndet (ursprung ”före ändring”); de nyaste behålls upp till antalet — egen, beskärbar retention.',
    diffTitle: 'Förhandsgranskning av ändringar',
    diffFailed: 'Förhandsgranskningen misslyckades',
    diffRetry: 'Försök igen',
    diffCounts: '{changed} ändras · {missing} skapas · {extra} överflödiga · {equal} identiska',
    diffChanged: 'ändras',
    diffMissing: 'skulle skapas',
    diffExtra: 'skulle tas bort',
    diffJsonb: 'jsonb-referenser kan inte verifieras före tillämpningen',
    diffSecret: 'förseglade fält, ej jämförbara',
    diffMore: '{n} till…',
    diffNeeded: 'Starten aktiveras när förhandsgranskningen speglar urvalet.',
    phase: 'Status',
    phaseRunning: 'pågår',
    phaseComplete: 'komplett',
    phaseError: 'fel',
    secrets: 'Hemligheter',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'placeholders',
    size: 'Storlek',
    created: 'Skapad',
    destination: 'Destination',
    download: 'Ladda ner .tvbk',
    deleteCheckpoint: 'Radera checkpoint',
    noCheckpoints: 'Inga checkpoints — skapa en från en destination.',
    families: 'Familjer',
    generation: 'Generation',
    completedAt: 'Slutförd den',
    errorDetail: 'Feldetalj',
    manifest: 'Manifest',
    restoreHint:
      'Ladda upp en .tvbk-artefakt: utforskaren visar vad den innehåller, sedan väljer du vad som ska återställas och hur.',
    uploadFile: 'Ladda upp en .tvbk-fil',
    uploading: 'Laddar upp…',
    uploadFailed: 'Kunde inte öppna artefakten',
    explorerTitle: 'Checkpointens innehåll',
    checkpointFrom: 'Checkpoint av klustret {cluster}, skapad den {when} ({origin}, generation {generation})',
    otherCluster:
      'Den här checkpointen kommer från ett ANNAT kluster ({cluster}) — cross-cluster-återställning kommer i en framtida runda.',
    encrypted: 'krypterad',
    objectsCount: '{n} objekt',
    mode: 'Läge',
    modeMerge: 'Merge — förenar: upsert av de valda, raderar ingenting',
    modeOverwrite:
      'Overwrite — checkpointen vinner: en helt vald familj ersätts i sin helhet (nuvarande rader som saknas i checkpointen dör)',
    restoreMasterpassHint:
      'Masterpassen som checkpointen skapades med. Utan den återställs de krypterade hemligheterna som explicita placeholders.',
    checkMasterpass: 'Verifiera',
    masterpassOk: 'Korrekt masterpass',
    masterpassWrong: 'Fel masterpass',
    parachuteDestination: 'Fallskärmsdestination',
    parachuteHint: 'Innan någon rad rörs skapar tasken här ett automatisk pre-återställnings-checkpoint.',
    summaryTitle: 'Vad som kommer att hända',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'hela familjen',
    summaryObjects: '{n} valda objekt',
    confirmHint:
      'Skriv klustrets namn ({name}) för att bekräfta — en återställning skriver om den deklarerade konfigurationen.',
    confirmField: 'Klustrets namn',
    startRestore: 'Återställ',
    restoreRunning: 'Återställning pågår…',
    restoreDone: 'Återställningen slutförd — reconcilerna konvergerar mot den nya deklarationen.',
    restoreFailed: 'Återställningen misslyckades',
    discard: 'Släng',
    selectionEmpty: 'Välj minst en familj eller ett objekt.'
  },

  backup: {
    intro: {
      title: 'Backup av VM- och containerdata',
      subtitle: 'Byggstenarna som extern backupprogramvara använder',
      whatItIs:
        'TVirt exponerar fyra primitiver: quiesced snapshots, change tracking per disk, read-only NBD-export och export av konfigurationen. Veeam, Bacula, Acronis och liknande styr dem.',
      whatItIsNot:
        'TVirt är ingen backupprodukt: den schemalägger inget, tillämpar ingen retention och lagrar inget arkiv av dina data. Retention, kataloger och återställningspolicyer stannar hos den programvara du redan använder.'
    },
    cbt: {
      title: 'Ändringsspårning',
      colVm: 'VM',
      colDisk: 'Disk',
      colState: 'Tillstånd',
      colBitmaps: 'Bitmappar',
      colObservedAt: 'Observerad',
      colChangeId: 'Change-ID',
      colMechanic: 'Mekanism',
      stateActive: 'Aktiv',
      stateInactive: 'Av',
      stateInconsistent: 'Inkonsekvent — nästa säkerhetskopia måste vara fullständig',
      stateBroken: 'Kedja bruten — inaktivera, aktivera sedan som ny kedja',
      stateSnapshots: 'Alltid på — delta mellan ögonblicksbilder',
      stateUnavailable: 'Inte tillgänglig på denna disk',
      mechanic: {
        'qcow2-bitmap': 'qcow2-bitmapp',
        'rbd-snapdiff': 'Ceph-snapshotdiff',
        'lvm-thin-delta': 'Thin pool-delta',
        none: 'Ingen'
      },
      empty:
        'Ingen VM-disk. Ändringsspårning läses per disk: aktivera den på en qcow2-disk, eller ta ögonblicksbilder på rbd/SAN.',
      chainBroken: 'Kedja bruten',
      chainBrokenText:
        'Bruten av en {reason}: {bitmaps}. Inaktivera bitmappen (kedjan är förlorad, nästa säkerhetskopia är fullständig) och aktivera den som ny kedja.',
      lineages: 'Epoker',
      epochFrozen: 'fryst i ögonblicksbild {snapshot}',
      epochLost: 'förlorad ({cause})',
      epochRecording: 'spelar in på huvudet',
      milestones: 'Milstolpar (ögonblicksbilder)',
      enable: 'Aktivera ändringsspårning',
      disable: 'Inaktivera',
      reset: 'Återställ',
      changedAreas: 'Ändrade områden',
      denied: 'Du saknar behörighet på denna VM',
      enableTitle: 'Aktivera ändringsspårning',
      disableTitle: 'Inaktivera ändringsspårning',
      resetTitle: 'Återställ bitmappen',
      areasTitle: 'Ändrade områden',
      bitmapName: 'Bitmappens namn',
      bitmapNameHint: 'Ett eget namn: tvirt- och tvbk- tillhör plattformen',
      granularity: 'Granularitet (byte)',
      granularityHint: 'En tvåpotens; 65536 som standard',
      bitmap: 'Bitmapp',
      disableHint: 'Tar bort bitmappen och hela dess epokhistorik: nästa säkerhetskopia måste vara fullständig.',
      resetHint: 'Tömmer bitmappen — en ny bas: ett change-ID från före återställningen kan inte längre sättas samman.',
      areasFrom: 'Från ögonblicksbild',
      areasTo: 'Till ögonblicksbild',
      areasRun: 'Beräkna',
      areasResult: '{count} ändrade områden, {bytes}',
      areasEmpty: 'Inget ändrat område mellan de två ögonblicksbilderna',
      areasZero: 'nollor',
      areasMore: 'de första {shown} av {count} visas',
      submit: 'Bekräfta',
      error: 'Åtgärden för ändringsspårning misslyckades'
    },
    exports: {
      title: 'Öppna NBD-exporter',
      colVm: 'VM',
      colDisk: 'Disk',
      colSnapshot: 'Ögonblicksbild',
      colBitmap: 'Bitmapp',
      colPhase: 'Fas',
      colNode: 'Nod',
      colEndpoint: 'Endpoint',
      colExpires: 'Går ut',
      colCreated: 'Öppnad',
      colError: 'Fel',
      phase: {
        preparing: 'Förbereder',
        ready: 'Klar',
        closed: 'Stängd',
        error: 'Misslyckades'
      },
      expiresIn: 'om {minutes} min',
      expired: 'utgången',
      empty: 'Ingen export. En lässession serverar en disk vid en ögonblicksbild till en NBD-klient; en skrivsession fyller en orörd disk på en stoppad VM. Båda dör när de löper ut.',
      endpointHint: 'TLS med klustrets CA; exportnamnet är biljetten — den dör med sessionen',
      closeDenied: 'Du saknar behörighet att stänga exporter på denna VM',
      open: 'Öppna NBD-export',
      openTitle: 'Öppna en NBD-export',
      openDisk: 'Disk',
      openBitmap: 'Bitmapp (valfri)',
      openBitmapHint:
        'Publicerar bitmappens epok fryst i denna ögonblicksbild som meta-context för de ändrade extenterna (endast qcow2-diskar)',
      openTtl: 'Livslängd (minuter)',
      openSubmit: 'Öppna',
      openError: 'Exporten kunde inte öppnas',
      colMode: 'Läge',
      mode: {
        read: 'Läsning',
        write: 'Skrivning'
      },
      caCertificate: 'Klustrets CA',
      caCopy: 'Kopiera PEM',
      caDownload: 'Ladda ned ca-cert.pem',
      caHint: 'Skriv PEM-filen till ca-cert.pem i en privat katalog och anslut med nbds://…?tls-certificates=<katalog> (nbdcopy, nbdinfo) eller --object tls-creds-x509,dir=<katalog>,endpoint=client (qemu-img)',
      caAbsent: 'Sessionen bär ingen CA (ingen PKI)',
      openWrite: 'Öppna skrivexport',
      openWriteTitle: 'Öppna en skrivexport',
      openWriteIntro: 'Disken måste vara orörd: född tom, aldrig skriven, utan ögonblicksbild; VM:en stoppad. Återställningen FYLLER disken, den reparerar den inte. Medan sessionen är öppen kan VM:en inte starta, ta ögonblicksbild eller klonas, och disken kan inte flyttas.',
      openWriteSubmit: 'Öppna',
      openWriteError: 'Skrivexporten kunde inte öppnas',
      openWriteDenied: 'Du saknar vm.restore.data på den här VM:en',
      openWriteStopped: 'Stoppa VM:en för att öppna en skrivexport',
      fromDescription: 'Skapa VM från beskrivning',
      fromDescriptionTitle: 'Skapa en VM från en beskrivning',
      fromDescriptionIntro: 'Beskrivningen från export-vm-meta kommer tillbaka som en stoppad VM med tomma diskar i den beskrivna geometrin — redo för skrivexporterna, disk för disk. Byten passerar inte här: restore-disk (CLI) eller backupproduktens NBD-klient bär dem.',
      fromDescriptionDoc: 'Beskrivning (JSON)',
      fromDescriptionDocHint: 'Klistra in dokumentet från export-vm-meta, eller välj filen',
      fromDescriptionFile: 'Välj fil…',
      fromDescriptionInvalid: 'Texten är inte ett JSON-dokument',
      fromDescriptionName: 'Namn på den nya VM:en',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Ditt hemscope',
      fromDescriptionStorage: 'Disklagring',
      fromDescriptionStorageHint: 'Varje disk föds här, i lagringens standardformat',
      fromDescriptionMetadataStorage: 'Metadatalagring',
      fromDescriptionSameAsStorage: 'Samma som diskarna',
      fromDescriptionBridge: 'Brygga',
      fromDescriptionBridgeHint: 'Utan brygga eller nätverk föds VM:en utan nätverkskort',
      fromDescriptionNetwork: 'Logiskt nätverk (fabric/nätverk)',
      fromDescriptionSubmit: 'Skapa',
      fromDescriptionError: 'VM:en kunde inte skapas',
      fromDescriptionDone: 'VM skapad: {name}',
      fromDescriptionOpen: 'Öppna VM:en',
      fromDescriptionDenied: 'Du saknar vm.create',
      fromDescriptionStillRunning: 'Skapandet pågår fortfarande: väntar vidare'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Datasäkerhetskopior av VM',
      titleOnVm: 'Datasäkerhetskopior',
      empty:
        'Ingen säkerhetskopia. En säkerhetskopia för över diskarna, UEFI-varstore och vTPM-tillståndet till en destination, och överlever den virtuella maskinen.',
      colVm: 'VM',
      colCreated: 'Tagen',
      colPhase: 'Utfall',
      colDestination: 'Destination',
      colContains: 'Innehåll',
      colSize: 'Storlek',
      colOrigin: 'Ursprung',
      colMode: 'Typ',
      retentionChip: 'Kvarhållning',
      retentionHint:
        'Destinationens kvarhållning kan radera den här säkerhetskopian utan att fråga: den föddes ur ett schema. Manuella säkerhetskopior sopas aldrig.',
      policyRemoved: 'Policy borttagen: {name}',
      policyRemovedHint:
        'Policyn som schemalade denna backup finns inte längre: ingen retention styr den (gallras aldrig automatiskt) — radera den för hand när den inte längre behövs.',
      phase: {
        running: 'Pågår',
        complete: 'Klar',
        error: 'Misslyckad'
      },
      origin: {
        manual: 'Manuell',
        schedule: 'Schemalagd'
      },
      mode: {
        full: 'Fullständig',
        incremental: 'Inkrementell'
      },
      contains: {
        disks: 'Diskar',
        varstore: 'UEFI-varstore',
        vtpm: 'vTPM-tillstånd',
        snapshots: 'Ögonblicksbilder'
      },
      vmState: {
        stopped: 'VM avstängd',
        running: 'VM igång (varm)'
      },
      artifactClass: { metadata: 'Metadata', data: 'Data', secret: 'Hemlighet' },
      detail: {
        tabOverview: 'Översikt',
        tabArtefact: 'Artefakt',
        id: 'Identifierare',
        scope: 'Omfattning',
        vmState: 'VM-tillstånd vid kopieringen',
        pointInTime: 'Datats tidpunkt',
        completedAt: 'Avslutad',
        node: 'Nod som kopierade',
        error: 'Fel',
        path: 'Katalog på lagringen',
        checksum: 'sha256 för manifestet',
        secretsExposed: 'Känsligt material i klartext',
        secretsExposedYes: 'Ja — destinationen krypterar inte',
        secretsExposedNo: 'Nej',
        baseBackup: 'Bassäkerhetskopia',
        tabManifest: 'Manifest',
        manifestHint:
          'Artefaktens index i klartext: en fil per rad med sin sha256. Katalogen går att verifiera utan TVirt — qemu-img, tar och jq räcker.',
        manifestEmpty: 'Manifestet listar inga filer.',
        manifestError: 'Manifestet går inte att läsa',
        colEntry: 'Fil',
        colClass: 'Klass',
        colSha: 'sha256'
      },
      create: {
        action: 'Säkerhetskopiera nu',
        title: 'Säkerhetskopiera nu',
        submit: 'Starta säkerhetskopieringen',
        destination: 'Destination',
        destinationHint: 'Endast destinationer som tar emot säkerhetskopior.',
        noDestinations: 'Ingen destination tar emot säkerhetskopior: skapa en under System → Checkpoints.',
        contentsHint:
          'Alla diskar följer med, plus UEFI-varstore och vTPM-tillståndet. De två sista är själva poängen: en förseglad gäst måste kunna starta igen.',
        error: 'Säkerhetskopieringen startade inte',
        stillRunning: 'Säkerhetskopieringen pågår fortfarande — kopian fortsätter även om du stänger.',
        vmRunning:
          'Den virtuella maskinen är {phase}: en säkerhetskopia kräver en stabil VM — avstängd för den kalla kopian, igång för den varma.'
      },
      restore: {
        action: 'Återställ',
        title: 'Återställ',
        intro:
          'Återställning är oåterkallelig. Välj vart data ska tillbaka: till en ny maskin, eller ovanpå den ursprungliga.',
        modeNewVm: 'Återställ till en NY VM',
        modeNewVmHint:
          'Rör inget av det som finns — det är alternativet man verifierar en säkerhetskopia med. Ny identifierare och nypräglade MAC-adresser.',
        modeOver: 'Skriv över den ursprungliga VM:en',
        modeOverHint:
          'Förstör mål-VM:ens nuvarande data, utan väg tillbaka. Den virtuella maskinen måste vara avstängd.',
        newName: 'Namn på den nya VM:en',
        newNameHint: 'Det måste vara ledigt i målets omfattning.',
        storage: 'Lagring för diskarna',
        storageHint: 'Obligatoriskt: manifestet noterar en disks storlek och format, aldrig lagringen den låg på.',
        metadataStorage: 'Lagring för varstore och vTPM',
        metadataStorageHint: 'Var UEFI-identiteten och vTPM-tillståndet landar.',
        sameAsStorage: 'Samma som diskarna',
        bridge: 'Värdens bridge',
        bridgeHint:
          'Varje registrerat nätverkskort kommer tillbaka på den här bridgen med en ny MAC. Lämnat tomt föds VM:en utan kort — det säkrare förvalet.',
        overwriteTitle: 'Du är på väg att skriva över den här VM:en',
        overwriteName: 'Namn',
        overwriteId: 'Identifierare',
        overwriteDisks: 'Diskar som skrivs över',
        overwriteNoDisks: 'Inga diskar.',
        overwriteKeeps:
          'Orörda förblir identifierare, namn, omfattning, nätverkskort och MAC-adresser: en säkerhetskopia är DATA, konfigurationen är checkpointen.',
        confirmField: 'VM:ens namn',
        confirmHint: 'Skriv {name} för att bekräfta.',
        targetLoading: 'Läser mål-VM:en…',
        targetRunning:
          'Mål-VM:en är {phase}: en återställning skriver om byten under gästen och kräver därför att den är avstängd.',
        targetGone: 'Den ursprungliga VM:en går inte längre att läsa: återställning till en ny VM återstår.',
        onlyComplete: 'Säkerhetskopian är {phase}: bara en färdig säkerhetskopia kan återställa.',
        submitNewVm: 'Återställ till den nya VM:en',
        submitOver: 'Skriv över',
        error: 'Återställningen startade inte',
        stillRunning: 'Återställningen pågår fortfarande — att kopiera hela diskar tar tid.'
      }
    },
    guest: {
      title: {
        ct: 'Datasäkerhetskopior av containrar',
        app: 'Datasäkerhetskopior av Appar'
      },
      tabTitle: 'Säkerhetskopior',
      empty:
        'Inga säkerhetskopior. En säkerhetskopia kopierar persistenta data till en destination och överlever sitt objekt.',
      colSubject: {
        ct: 'Container',
        app: 'App'
      },
      colCreated: 'Tagen',
      colPhase: 'Utfall',
      colDestination: 'Destination',
      colContains: 'Innehåll',
      colSize: 'Storlek',
      colOrigin: 'Ursprung',
      policyRemoved: 'Policy borttagen: {name}',
      policyRemovedHint:
        'Policyn som schemalade denna backup finns inte längre: ingen retention styr den (gallras aldrig automatiskt) — radera den för hand när den inte längre behövs.',
      phase: {
        running: 'Pågår',
        complete: 'Slutförd',
        error: 'Misslyckad'
      },
      origin: {
        manual: 'Manuell',
        schedule: 'Schemalagd'
      },
      state: {
        stopped: 'Objekt stoppat',
        running: 'Objekt igång (fryst)'
      },
      contains: {
        rootfs: 'Rootfs-träd',
        config: 'Konfiguration',
        volumes: 'Persistenta volymer',
        root: 'Persistent root'
      },
      artifactClass: {
        metadata: 'Metadata',
        data: 'Data',
        secret: 'Hemlig'
      },
      create: {
        action: 'Säkerhetskopiera nu',
        title: 'Ny säkerhetskopia',
        submit: 'Starta säkerhetskopian',
        error: 'Säkerhetskopian startade inte',
        destination: 'Destination',
        destinationHint: 'Endast destinationer som accepterar datasäkerhetskopior.',
        noDestinations:
          'Ingen destination accepterar datasäkerhetskopior: lägg till “Datasäkerhetskopior” på en destination.',
        hint: {
          ct: 'Hela rootfs-trädet reser med, troget (numeriska ägare, xattrs, ACL:er), plus den deklarerade konfigurationen i manifestet. En körande container FRYSES under hela packningen: kraschkonsistent kopia, deklarerad.',
          app: 'ENDAST de persistenta volymerna (och den persistenta rooten) reser med, plus konfigurationen i manifestet. Det efemära är uteslutet per ratificering och manifestet namnger det; env-värden deklarerade hemliga reser inte.'
        },
        stillRunning: 'Säkerhetskopian pågår ännu — att packa hela träd tar tid.'
      },
      detail: {
        tabOverview: 'Översikt',
        tabManifest: 'Manifest',
        id: 'Identifierare',
        scope: 'Omfång',
        state: 'Tillstånd vid kopian',
        pointInTime: 'Data per ögonblick',
        completedAt: 'Avslutad',
        node: 'Nod som kopierade',
        error: 'Fel',
        path: 'Katalog på lagringen',
        checksum: 'manifest-sha256',
        manifestHint:
          'Artefaktens index: en post per fil med dess sha256 — utan hashar är “säkerhetskopian finns” en troshandling.',
        manifestError: 'Manifestet kan inte läsas',
        manifestEmpty: 'Inga artefakter i manifestet.',
        colEntry: 'Fil',
        colClass: 'Klass',
        colSha: 'sha256',
        excluded: 'Utesluten per ratificering (reser inte)',
        secretKeys: 'Utelämnade hemliga env-nycklar (#307) — mata in dem igen efter en återställning'
      },
      restore: {
        action: 'Återställ',
        title: 'Återställning',
        submit: 'Återställ',
        error: 'Återställningen startade inte',
        stillRunning: 'Återställning pågår ännu — att packa upp hela träd tar tid.',
        onlyComplete: 'Säkerhetskopian är {phase}: endast en slutförd kopia kan återställa.',
        asNew: {
          ct: 'I en NY container — förstör inget: gesten man kontrollerar en säkerhetskopia med',
          app: 'I en NY App — förstör inget: gesten man kontrollerar en säkerhetskopia med'
        },
        over: {
          ct: 'ÖVER källcontainern — hela rootfs-trädet ersätts',
          app: 'ÖVER käll-Appen — innehållet i varje persistent volym ersätts'
        },
        name: 'Namn på det nya objektet',
        storage: 'Lagring',
        storageHint: 'Där de återställda data landar — manifestet registrerar aldrig den förlorade poolen.',
        storageDeclared: 'Lagringarna deklarerade i manifestet',
        bridge: 'Värd-bridge',
        bridgeHint:
          'Varje registrerat nätverkskort kommer tillbaka på denna bridge med en färsk MAC. Tom = född okopplad, den säkraste standarden.',
        node: 'Nod',
        nodeHint: 'Medlemmen Appen återföds på: noden är klusteridentitet och kommer aldrig från manifestet.',
        secretKeysWarning:
          'Env-värden deklarerade hemliga reser inte i säkerhetskopian: den återfödda kopian vill ha dem inmatade igen (task-loggen namnger nycklarna).',
        overInventory: 'Du är på väg att skriva över detta objekt',
        confirmType: 'Skriv {name} för att bekräfta',
        targetGone: 'Källobjektet kan inte längre läsas: återställning som nytt är fortfarande möjlig.',
        targetLoading: 'Läser målobjektet…',
        targetRunning: 'Målobjektet kör: en återställning ersätter bytes under gästen och vill ha det stoppat.'
      }
    }
  }
}
